import { useFeatureValue } from '@growthbook/growthbook-react';
import { NEW_UI_FLAG } from '@/constants';

export default function useNewUiScope(scope: NewUiScope): boolean {
  const scopes = useFeatureValue<Record<string, boolean>>(
    NEW_UI_FLAG,
    NEW_UI_SCOPES_DEFAULT,
  );
  return scopes[scope] ?? false;
}

export const NEW_UI_SCOPES_DEFAULT = {
  studentDashboard: false,
  teacherDashboard: false,
  manageKlasses: false,
  manageScheduledLessonReport: false,
  manageStudents: false,
  studentCourseLessons: false,
  staffCourseLessons: false,
  studentActivities: false,
  appShell: false,
} satisfies Record<string, boolean>;

export type NewUiScope = keyof typeof NEW_UI_SCOPES_DEFAULT;
